import { createFileRoute, redirect } from '@tanstack/react-router'

import type { FilterSearchParams } from '@/components/common/filters/types'
import { INVENTORY_FILTERS } from '@/components/reports/inventory-tab'

interface ReportsSearch extends FilterSearchParams {
    tab?: string
}

/**
 * Trang Báo cáo cũ gom 7 tab trên một URL (`/reports?tab=…`). Nay mỗi tab là
 * một trang con trong menu Báo cáo; bảng này giữ cho link cũ (bookmark, link
 * đã gửi qua Zalo) vẫn mở đúng báo cáo.
 */
const REPORT_TAB_PATHS = {
    revenue: '/reports/revenue',
    geography: '/reports/geography',
    'yield-loss': '/reports/yield-loss',
    debts: '/reports/debts',
    staff: '/reports/staff',
    delivery: '/reports/delivery',
} as const

type ReportTabPath =
    | (typeof REPORT_TAB_PATHS)[keyof typeof REPORT_TAB_PATHS]
    | '/reports/inventory'

/** Tab lạ hoặc không có tab → Doanh thu, đúng như tab mặc định trước đây. */
export const reportPathForTab = (tab: string | undefined): ReportTabPath => {
    if (tab === 'inventory') return '/reports/inventory'
    return (
        REPORT_TAB_PATHS[tab as keyof typeof REPORT_TAB_PATHS] ??
        REPORT_TAB_PATHS.revenue
    )
}

/** Bộ lọc tồn kho nằm trên URL cũ phải đi theo sang trang Tồn kho mới. */
export const validateReportsSearch = (
    search: Record<string, unknown>,
): ReportsSearch => ({
    ...INVENTORY_FILTERS.validateSearch(search),
    tab: typeof search.tab === 'string' ? search.tab : undefined,
})

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/')({
    validateSearch: validateReportsSearch,
    beforeLoad: ({ search }) => {
        const { tab, ...inventoryFilters } = search
        const to = reportPathForTab(tab)
        if (to === '/reports/inventory') {
            throw redirect({ to, search: inventoryFilters, replace: true })
        }
        throw redirect({ to, replace: true })
    },
})
